// extracted by mini-css-extract-plugin
export default {"root":"_292FI","heading-and-description":"GxWTj","headingAndDescription":"GxWTj","footer":"zARz6"};